import { DevelopusTreeTableHeadType } from '../DevelopusTreeTableHead'
import DevelopusTreeTableCellsUIModel from './DevelopusTreeTableCellsUIModel'

class DevelopusTreeTableHeadUIModel {
  constructor(cells: DevelopusTreeTableCellsUIModel) {
    this.cells = cells
  }

  private readonly cells: DevelopusTreeTableCellsUIModel

  toUI(): DevelopusTreeTableHeadType {
    return {
      cells: this.cells.toUI(),
    }
  }
}

export default DevelopusTreeTableHeadUIModel
